import { useState } from 'react'

/**
 * A figure the API could not give, inline: its short label, and why. The label is a
 * disclosure button, so the reason reaches a keyboard or touch reader as well as a hover
 * (`title`) or a screen reader (the hidden sentence, while it is closed).
 */
export function Reasoned({ label, why }: { label: string; why: string }) {
  const [open, setOpen] = useState(false)
  return (
    <span className="aov-reasoned">
      <button type="button" className="aov-reasoned__toggle" title={why} aria-expanded={open} onClick={() => setOpen((value) => !value)}>
        {label}
      </button>
      {open ? <span className="aov-reasoned__why">{why}</span> : <span className="ci-visually-hidden">. {why}</span>}
    </span>
  )
}
